export interface 卸型 {
  卸コード: string;
  卸名: string;
  卸名カナ: string;
  EOS卸コード: string;
  EOS卸サブコード: string;
  納品予定指定可能日数: number;
  ほくやくフラグ: string | null;
  備蓄センターフラグ: string | null;
  表示順: number;
  発注単位区分: string;
  複写フラグ: string;
  医薬品発注有効区分: string;
  その他品発注有効区分: string;
  備蓄品発注有効区分: string;
  更新バージョン: number;
  削除フラグ: string;
}

export const 卸初期値 = {
  卸コード: '',
  卸名: '',
  卸名カナ: '',
  EOS卸コード: '',
  EOS卸サブコード: '',
  納品予定指定可能日数: 0,
  ほくやくフラグ: null,
  備蓄センターフラグ: null,
  表示順: 0,
  発注単位区分: '箱',
  複写フラグ: '複写なし',
  医薬品発注有効区分: '無効',
  その他品発注有効区分: '無効',
  備蓄品発注有効区分: '無効',
  更新バージョン: 0,
  削除フラグ: '未削除',
};

export interface EOS卸型 {
  EOS卸コード: string;
  EOS卸サブコード: string;
  卸名: string;
  卸名カナ: string;
  納品予定指定可能日数: number;
  備蓄センターフラグ: string;
}

